import API_URL from '../config';
import { getLocalDateString } from '../utils/formatters';
import { getAuthHeaders } from '../utils/api';

// Get today's daily puzzle (uses client's local date to ensure correct puzzle)
export const getDailyPuzzle = async () => {
  const localDate = getLocalDateString();

  const response = await fetch(`${API_URL}/api/daily?date=${localDate}`, {
    headers: getAuthHeaders({ json: true, includeGuestId: true }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch daily puzzle');
  }

  return response.json();
};

// Get daily puzzle for a specific date
export const getDailyPuzzleByDate = async (date) => {
  const response = await fetch(`${API_URL}/api/daily/date/${date}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch daily puzzle');
  }

  return response.json();
};

// Get user's progress on today's puzzle
export const getDailyProgress = async () => {
  const localDate = getLocalDateString();
  const response = await fetch(`${API_URL}/api/daily/progress?date=${localDate}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch progress');
  }

  return response.json();
};

// Send heartbeat to track active play time (anti-cheat)
// resume=true resets lastHeartbeat without accumulating time (used after pause/refresh)
export const sendHeartbeat = async (resume = false) => {
  const localDate = getLocalDateString();
  const url = `${API_URL}/api/daily/heartbeat?date=${localDate}${resume ? '&resume=true' : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: getAuthHeaders({ json: true, includeGuestId: true }),
  });

  if (!response.ok) {
    return { success: false };
  }

  return response.json();
};

// Save progress on today's puzzle
export const saveDailyProgress = async (progressData) => {
  const localDate = getLocalDateString();
  const response = await fetch(`${API_URL}/api/daily/progress?date=${localDate}`, {
    method: 'PATCH',
    headers: getAuthHeaders({ json: true, includeGuestId: true }),
    body: JSON.stringify(progressData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to save progress');
  }

  return response.json();
};
